export default __webpack_public_path__ + "static/media/qui1.deb31ba0.png";